module.exports = __webpack_public_path__ + "static/media/request-display.bbd8cdfa.png";